﻿export function initOndertekendBevestigingPage() {
    const cesKey = document.querySelector("[data-ces-key]")?.dataset?.cesKey;
    window.customerEffortScore.trigger(cesKey);
}